import {NgModule} from "@angular/core";
import {WidthOverflowDirective} from "./width.overflow.directive";
import {CPTooltipModule} from "../../components/tooltip/tooltip.module";

@NgModule({
	declarations: [WidthOverflowDirective],
	exports: [WidthOverflowDirective, CPTooltipModule]
})
export class WidthOverflowModule {

}
